import { useEffect } from 'react';

import { Accordion } from '@iwoca/orion';

import styles from './BankStatementUploadRevamp.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DragDropUpload from '../components/DragDropUpload/DragDropUpload';
import FileStatusSections from '../components/FileStatusSections/FileStatusSections';

const DOCUMENT_TYPE = 'bank statement';

const listOfInstructions = [
  <>
    You can download these from your online banking.{' '}
    <a
      href="https://static.iwoca.com/pdf/iwoca_bank_statement_pdf_download_guide.pdf"
      target="_blank"
      rel="noreferrer"
    >
      See instructions
    </a>
    .
  </>,
  'Files must be PDF or JPG, JPEG, PNG and no more than 2GB.',
  'These should be for the account(s) where the majority of your business revenue is generated.',
  'Please ensure the statements display the business name, sort code, account number and the account balance.',
];

const BankStatementUploadRevamp = () => {
  const stateKey = useContextStateKey();
  const { documents } = useGetDocuments(stateKey);

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  useEffect(() => {
    if (documents) {
      const bankStatementDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(bankStatementDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      <Accordion
        title="If you prefer, you can upload your latest 6 months of bank statements (PDF)"
        small
        variant="secondary"
        data-testid="bank-statement-upload-accordion"
        titleClassName={styles.accordionHeader}
      >
        <DragDropUpload
          documentType={DOCUMENT_TYPE}
          listOfInstructions={listOfInstructions}
          setFileLoading={setFileLoading}
          setFileSuccess={setFileSuccess}
          setFileError={setFileError}
          setFileReject={setFileReject}
        />
      </Accordion>

      <FileStatusSections files={uploadedFiles} removeFile={removeFile} />
    </div>
  );
};

export default BankStatementUploadRevamp;
